import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { MessService } from 'src/app/_services/mess-service.service';
import { ProductTypesService } from 'src/app/_services/product-types.service';

@Component({
  selector: 'app-product-types-edit',
  templateUrl: './product-types-edit.component.html',
  styleUrls: ['./product-types-edit.component.scss'],
})
export class ProductTypesEditComponent implements OnInit, OnDestroy {
  updateProductTypeForm: FormGroup;
  productTypeName: string;
  productTypeId: number;

  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private productTypesService: ProductTypesService,
    private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messService: MessService
  ) {}

  ngOnInit(): void {
    this.productTypeId = this.route.snapshot.params['id'];
    this.productTypeName = this.route.snapshot.queryParams.name;

    this.updateProductTypeForm = this.fb.group({
      name: [this.productTypeName, Validators.required],
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  onUpdateProductType() {
    const productType = this.updateProductTypeForm.getRawValue();
    this.subscriptions.push(
      this.productTypesService
        .updateProductType(this.productTypeId, productType)
        .subscribe(
          () => {
            this.messService.add({
              severity: 'success',
              title: 'Uspešna izmena',
              detail: `Izmenili ste tip koji ima ID: ${this.productTypeId}.`,
            });
            this.router.navigate(['/product_types']);
          },
          (error) => {
            const errorObj = error.error.errors;
            const form = this.updateProductTypeForm;
            const messService = this.messService;
            Object.keys(errorObj).forEach(function (key) {
              const formControl = form.get(key);
              if (formControl) {
                // If error exist set red border to field
                formControl.setErrors({});
              }
              // Push toast error for every field
              messService.addError({
                severity: 'error',
                title: 'Greška',
                detail: errorObj[key],
                sticky: true,
              });
            });
          }
        )
    );
  }

  onDeleteProductType(event: Event) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete tip?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.productTypesService
          .deleteProductType(this.productTypeId)
          .subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Obrisali ste tip.',
              });
              this.router.navigate(['/product_types']);
            },
            (error) => {
              this.messService.addError({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
                sticky: true,
              });
            }
          );
      },
    });
  }
}
